// removed by extract-text-webpack-plugin
module.exports = {"container":"FullscreenModalPopup__container__3-Gz2","popupBox":"FullscreenModalPopup__popupBox__1AlQB","titleRow":"FullscreenModalPopup__titleRow__3ctER","contentRow":"FullscreenModalPopup__contentRow__xUctS","btnRow":"FullscreenModalPopup__btnRow__2YArq","btn":"FullscreenModalPopup__btn__2mPzr"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/FullscreenModalPopup/FullscreenModalPopup.css
// module id = 509
// module chunks = 0